import styled, { css } from 'styled-components';

import { variableFontRegular } from 'styles/theme/text';
import { VariantDetail } from 'productTemplate/components/buyBar/VariantDetail';
import { Window } from 'shared/components/Window';
import { VariantDetailLinkHeader } from 'productTemplate/components/buyBar/VariantDetailLinkHeader';
import { IProduct } from 'shared/types/Product';
import { IProductSearch } from 'shared/types/ProductSearch';
import { WantProductButton } from 'wants/components/WantProductButton';
import { WindowHeader } from 'shared/components/Window/WindowHeader';
import { useStoreDispatch, useStoreSelector } from 'store/hooks/storeHooks';
import { removeWindow } from 'store/slice/pdpStateSlice';
import { t } from 'localization/utils/t';

const TP = 'productTemplate.components.windows.VariantDetailWiondow';

export interface IVariantDetailWindowProps {
  variantData: IProduct | IProductSearch;
}

export const VariantDetailWindow = ({ variantData }: IVariantDetailWindowProps) => {
  const { id } = variantData;
  const storeDispatch = useStoreDispatch();
  const { openWindows } = useStoreSelector((state) => state.pdpState);

  const onClose = () => {
    storeDispatch(removeWindow(variantData));
  };

  const { positionOffset } = openWindows.find((w) => w.id === id);

  const title = (
    <VariantDetailLinkHeader
      href="/buyer-protection-guarantee"
      title={t(`${TP}.variantDetailLinkHeader`, 'Buyer Protection Guaranteed')}
      after={<VariantDetailWindow.WantProductButton productId={id} />}
    />
  );

  return (
    <VariantDetailWindow.Window
      data-qa="used_detail_window"
      id={String(id)}
      isPermanent
      onClose={onClose}
      title={title}
      xButtonSize={8}
      $positionOffset={positionOffset}
    >
      <VariantDetailWindow.VariantDetail variantData={variantData} isMobile={false} />
    </VariantDetailWindow.Window>
  );
};

VariantDetailWindow.Window = styled(Window)<{ $positionOffset: number }>`
  position: absolute;
  min-height: 200px;

  ${({ $positionOffset }) => css`
    bottom: calc(${$positionOffset}px);
    left: calc(74.95% + ${$positionOffset}px);
  `};
  ${WindowHeader.Wrapper} {
    padding: 12px 16px 16px 16px;
  }
`;

VariantDetailWindow.VariantDetail = styled(VariantDetail)`
  padding: 0px 16px 16px;
`;

VariantDetailWindow.WantProductButton = styled(WantProductButton)`
  margin-top: -6px;
  margin-bottom: -6px;
  padding: 2px 4px;
  ${variableFontRegular({ size: '11.5px', height: '14px' })};
  border: ${({ theme }) => theme.borders.black};
  &:active {
    border: ${({ theme }) => theme.borders.black};
  }
`;
